import { tabBarNavigateStore } from '~/modules/tabBar/stores/tabBarNavigateStore';
import { ETabBarSegments } from '~/modules/tabBar/configs/tabBarConfig';

export const useTabBarSetup = () => {
  const router = useRouter();
  const tabBarStore = tabBarNavigateStore();

  onMounted(() => {
    tabBarStore.setupActiveSegment(router.currentRoute.value);
  });

  onUnmounted(() => {
    tabBarStore.activeSegment = ETabBarSegments.UnUsed;
  });
};
